<template>
  <div class="new_sports_item">
    <!-- <Empty description="暂无数据"  /> -->
    <template v-if="subItemList.length>0">
      <div class="tabbody item">
        <div slot="title" class="sports_item_rule_img" @click="goquest">
          <VanImage
            v-if="item.id == 205"
            src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220805/1659669998/559460.png"
            fit="cover"
            width="100%"
            height="100%"
          />
        </div>
        <div class="new_list" v-if="item.id == 205">
          <div class="new_item" v-for="item in subItemList" :key="item.id" @click="goDetail(item)">
            <div>
              <img :src="item.icon" alt="">
            </div>
            <div>
              <div class="it">{{item.title}}</div>
              <div class="cont"><img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220326/1648297476/428663.png"  alt="">时间：{{item.start_time_show}} ～ {{item.end_time_show}}</div>
            </div>
          </div>
        </div>
        <PushUpsList v-else :pushUpsList="subItemList" v-on:goDetail="goDetail"></PushUpsList>
          
      </div>
        
    </template>
    <!-- <template v-if="subItemList.length===1">
      <div
        class="tabbody only"
      >
        <div
          class="header"
        >{{title}}</div>
        <div class="html" v-html="rule"></div>
      </div>
    </template> -->
    <template v-if="subItemList.length===0">
      <div
        class="tabbody no"
      >
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220730/1659166958/431875.png" alt="">
      </div>
    </template>
    <van-dialog
      v-model="showRule"
      class="sports_item_rule_dialog rule"
      :show-confirm-button="false"
      close-on-click-overlay
    >
      <van-icon
        name="close"
        style="position:fixed;right:10px;"
        size=".4rem"
        @click="showRule=false"
      />
      <div
        class="rule"
      >
        <div
          class="header"
          slot="title"
        >{{title}}</div>
        <div v-html="rule"></div>
      </div>
    </van-dialog>
    <!-- <Button
      round    
      @click="goDetail(subItemList[0])"
      class="mvbutton"
      style="width: 100%;"
      block
      v-if="enableActivity"
    >去看看</Button> -->
  </div>
</template>

<script>
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag, Row } from "vant";
import "./item.less";
import PushUpsList from '@/components/PushUpsList'
export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      return detail.tabstyle[0]["color"];
    }
  },
  components: {
    Empty,
    Cell,
    CellGroup,
    Skeleton,
    Button,
    VanImage: Image,
    Tag,
    PushUpsList
  },
  props: ["item", "detail", "sports_id"],
  watch: {
    item: {
      handler: "getItemInfo",
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      showRule: false,
      subItemList: [],
      title: "",
      rule: "",
      enableActivity: false,
      scoreType: 1,
      content: "",
      canjoin: "",
      bannerList: [],
      userInfo: {}
    };
  },
  mounted() {
    this.getbanner()
    this.getUserInfo()
  },
  methods: {
    goquest() {
      this.$router.push({name:'newanswer',params: {acid: 1076}})
    },
    onCe() {
      this.$router.push({name:'healthselftest'})
    },
    getUserInfo() {
        this.$api.user.getUserInfo().then((res) => {
            if (res.status * 1 === 200) {
                this.userInfo = res.data
            }
        })
    },
    getbanner() {
        this.$api.common.getBanners({position:2}).then((res)=>{
            this.bannerList =  res.data
        })
    },
    go(val) {      
      let that = this
      var {jumptype, jumpvalue, jumpurl} = val;
        //跳转类型：1，内部跳转；2，外部url跳转
      switch (jumptype * 1) {
            case 1:
              wx.miniProgram.navigateTo({
                url: val.register_type_value
              })
                break;
            case 2:
                //参数带上 用户信息
                // if(data.url)
                window.location.href = jumpurl
                break;
            case 3:
                that.show = true
                // that.$toast.fail('该功能只对小程序开放');
                break;
        }
    },
    goDetail(val) {
      if(val.register_type == 2){
        window.location.href = val.register_type_value
        return
      }
      let that = this
      if(val.register_type_value){
        if(val.register_type_value.indexOf('http')!=-1){
          window.location.href = val.register_type_value
        } else {
          wx.miniProgram.navigateTo({
              url: val.register_type_value
          })
        }
        
        return
      }
      this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_id:this.item.id,item_sub_id:val.id}})
    },
    getItemInfo() {
      if(!this.item.id) return
      this.subItemList = [];
      this.rule = "";
      this.enableActivity = false
      this.$api.sports.getItemSubs({ itemid: this.item.id }).then((res) => {
        this.subItemList = res.data.list;
        this.title = res.data.title;
        this.content = res.data.content;
        this.rule = res.data.rule;
        this.scoreType = res.data.score_type;
        this.canjoin = res.data.canjoin;
        if (+res.data.list.length === 1) {
          let {
            title,
            start_time,
            end_time,
            vote_start_time,
            vote_end_time,
          } = res.data.list[0];
          // this.title = title;
          this.enableActivity = res.sys_time > start_time;
        }
      });
    },
  },
};
</script>
